import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loadingComponent",
  initialState: {
    loading: false,
    isTextVisible: false,
  },
  reducers: {
    openLoading: {
      reducer: (state, action: PayloadAction<{ isTextVisible?: boolean } | undefined>) => {
        state.loading = true;
        state.isTextVisible = action.payload?.isTextVisible ?? false;
      },
      prepare: (options?: { isTextVisible?: boolean }) => ({ payload: options }),
    },
    closeLoading: (state) => {
      state.loading = false;
      state.isTextVisible = false;
    },
  },
});

export const selectStateLoading = (state: {
  trackingApp: {
    loadingComponent: { loading: boolean; isTextVisible: boolean };
  };
}) => state.trackingApp.loadingComponent.loading;

export const selectIsTextVisible = (state: {
  trackingApp: {
    loadingComponent: { loading: boolean; isTextVisible: boolean };
  };
}) => state.trackingApp.loadingComponent.isTextVisible;

export const { openLoading, closeLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
